export default "__VITE_ASSET__92982310__"